import React, { useState, useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './BrandOnboardingOverlay.scss';

const BrandOnboardingOverlay = props => {
  const { onRequestClose, children } = props;

  const [pageChromeOffset, setPageChromeOffset] = useState(0);
  // Ref so the escape listener (bound once on mount) always sees the current form state.
  const onRequestCloseRef = useRef(onRequestClose);
  onRequestCloseRef.current = onRequestClose;

  // Anchored below the sticky admin nav; useLayoutEffect so the first frame doesn't paint at top 0.
  useLayoutEffect(() => {
    const measureNavOffset = () => {
      const adminNav = document.querySelector('.admin-nav-header');
      setPageChromeOffset(adminNav ? adminNav.getBoundingClientRect().bottom : 0);
    };
    measureNavOffset();
    document.body.style.overflow = 'hidden';

    const closeOnEscape = e => e.key === 'Escape' && onRequestCloseRef.current();
    window.addEventListener('keydown', closeOnEscape);
    window.addEventListener('resize', measureNavOffset);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', closeOnEscape);
      window.removeEventListener('resize', measureNavOffset);
    };
  }, []);

  return (
    <div className='brand-onboarding-overlay-outer-container' style={{ top: pageChromeOffset }}>
      <div className='brand-onboarding-overlay-inner-container' onMouseDown={e => e.target === e.currentTarget && onRequestClose()}>
        {children}
      </div>
    </div>
  );
};

BrandOnboardingOverlay.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default BrandOnboardingOverlay;
